import { render, staticRenderFns } from "./RentCouponCard.vue?vue&type=template&id=4f8d5936&scoped=true&"
import script from "./RentCouponCard.vue?vue&type=script&lang=ts&"
export * from "./RentCouponCard.vue?vue&type=script&lang=ts&"
import style0 from "./RentCouponCard.vue?vue&type=style&index=0&id=4f8d5936&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8d5936",
  null
  
)

export default component.exports